import { ResourcefulReducer } from '../../util';
import PageModel from '../models/page_model';

const PageReducer = new ResourcefulReducer('pages', PageModel, {
});

export default PageReducer;
